import React, { useEffect, useState } from "react";
import { Card, CardHeader } from "../../../../_metronic/_partials/controls";
import axios from "axios";
import { fetchProducts } from "../../../../app/modules/Base/_redux/products/productsActions";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {changeCategory} from "../../../../app/modules/Sale/_redux/orders/ordersActions";

const apiEndpoint = process.env.REACT_APP_API_URL;

const OrderFilterBox = () => {
  const [categories, setCategories] = useState([]);
  
    const dispatch = useDispatch();
  const {selectedCategory} = useSelector(
      (state) => ({
          selectedCategory: state.orders.selectedCategory,
      }),
      shallowEqual
  )
  

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await axios.get(`${apiEndpoint}/Category/Grouped`);
        setCategories(data.data);
      } catch (error) {
        console.log(error);
      }
    };

    getCategories();
  }, []);

  return (
    <Card>
      <CardHeader title={"فیلتر محصولات"} />

      <div
        className="media-body p-4"
        style={{
          minWidth: "100px",
          maxWidth: "350px",
        }}
      >
        <div
          className={`d-flex justify-content-between rounded-sm pl-2 lead mb-4`}
        >
          <div>همه</div>

          <div>
            <label className="checkbox checkbox-lg checkbox-light-primary checkbox-single flex-shrink-0 m-0 mx-4">
              <input
                type="checkbox"
                onChange={() => {
                  dispatch(changeCategory(null));
                }}
                checked={!selectedCategory}
              />
              <span></span>
            </label>
          </div>
        </div>

        {categories.map((category) => (
          <div
            className={`d-flex justify-content-between rounded-sm pl-2 lead mb-4`}
            key={category.id}
          >
            <div>{category.name}</div>

            <div>
              <label className="checkbox checkbox-lg checkbox-light-primary checkbox-single flex-shrink-0 m-0 mx-4">
                <input
                  type="checkbox"
                  onChange={() => {
                    dispatch(changeCategory(category.id));
                  }}
                  checked={selectedCategory === category.id}
                />
                <span></span>
              </label>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default OrderFilterBox;
